import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const SEND_OFFER_EMAIL_MUTATION = gql`
  mutation sendOfferEmail(
    $offerDocumentId: DocumentVersionInput!
    $settings: SendOfferEmailSettingsInput!
  ) {
    sendOfferEmail( data: {
      offerDocumentId: $offerDocumentId
      settings: $settings
    }
    ) {
      accepted
      rejected
      response
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SendOfferEmailMutation extends Mutation<RootMutation> {
  document = SEND_OFFER_EMAIL_MUTATION;
}
